// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageWithPlaceholder_image__V2rBD"};